export function DiscountIcon({ color }) {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0_3670:49517"
				style={{ maskType: "alpha" }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="14"
				height="14"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.332031 0.332031H13.6672V13.666H0.332031V0.332031Z"
					fill={color}
				/>
			</mask>
			<g mask="url(#mask0_3670:49517)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.29528 12.3821C6.68861 12.7661 7.32194 12.7614 7.71261 12.3687L8.19394 11.8887C8.56728 11.5161 9.08328 11.3034 9.60928 11.3034H10.2959C10.8519 11.3034 11.3039 10.8514 11.3039 10.2961V9.61006C11.3039 9.07606 11.5106 8.57406 11.8879 8.19606L12.3679 7.71539C12.5633 7.51939 12.6679 7.26539 12.6673 6.99606C12.6666 6.72739 12.5606 6.47472 12.3693 6.28406L11.8886 5.80272C11.5106 5.42206 11.3039 4.92072 11.3039 4.38672V3.70206C11.3039 3.14606 10.8519 2.69406 10.2959 2.69406H9.61061C9.07661 2.69406 8.57461 2.48672 8.19661 2.11139L7.71528 1.62939C7.31461 1.23272 6.67528 1.23472 6.28394 1.62872L5.80461 2.10939C5.42194 2.48739 4.91994 2.69406 4.38794 2.69406H3.70194C3.14661 2.69472 2.69461 3.14672 2.69461 3.70206V4.38539C2.69461 4.91939 2.48728 5.42139 2.11128 5.80006L1.63794 6.27406C1.63328 6.27939 1.62861 6.28339 1.62394 6.28806C1.23261 6.68206 1.23461 7.32139 1.62861 7.71272L2.10994 8.19406C2.48728 8.57272 2.69461 9.07472 2.69461 9.60872V10.2961C2.69461 10.8514 3.14594 11.3034 3.70194 11.3034H4.38661C4.92128 11.3041 5.42328 11.5114 5.80128 11.8881L6.28194 12.3674C6.28594 12.3721 6.29061 12.3767 6.29528 12.3821ZM6.99785 13.6663C6.48651 13.6663 5.97518 13.473 5.58385 13.085C5.57851 13.0796 5.57318 13.0743 5.56785 13.0683L5.09451 12.5956C4.90585 12.4083 4.65385 12.3043 4.38585 12.3036H3.70185C2.59451 12.3036 1.69451 11.403 1.69451 10.2963V9.60896C1.69451 9.34096 1.58985 9.08962 1.40185 8.90029L0.922513 8.42162C0.143846 7.64696 0.134513 6.38562 0.899179 5.59896C0.905179 5.59296 0.911179 5.58696 0.917179 5.58096L1.40251 5.09429C1.58985 4.90562 1.69451 4.65296 1.69451 4.38562V3.70229C1.69451 2.59562 2.59451 1.69496 3.70118 1.69429H4.38785C4.65518 1.69429 4.90718 1.58962 5.09851 1.40096L5.57518 0.922956C6.35451 0.138289 7.62851 0.134289 8.41451 0.915622L8.90185 1.40296C9.09051 1.59029 9.34251 1.69429 9.61051 1.69429H10.2958C11.4032 1.69429 12.3038 2.59496 12.3038 3.70229V4.38696C12.3038 4.65429 12.4078 4.90696 12.5965 5.09696L13.0752 5.57629C13.4545 5.95296 13.6652 6.45629 13.6672 6.99296C13.6692 7.52962 13.4618 8.03429 13.0838 8.41496L12.5952 8.90229C12.4078 9.09096 12.3038 9.34229 12.3038 9.61029V10.2963C12.3038 11.403 11.4032 12.3036 10.2965 12.3036H9.60918C9.34518 12.3036 9.08718 12.4103 8.89985 12.5963L8.42118 13.075C8.02985 13.469 7.51385 13.6663 6.99785 13.6663Z"
					fill={color}
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.28499 9.21232C5.15699 9.21232 5.02899 9.16366 4.93166 9.06566C4.73632 8.87032 4.73632 8.55432 4.93166 8.35899L8.35832 4.93166C8.55366 4.73632 8.87032 4.73632 9.06566 4.93166C9.26099 5.12699 9.26099 5.44366 9.06566 5.63899L5.63832 9.06566C5.54099 9.16366 5.41299 9.21232 5.28499 9.21232Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.66609 9.32943C8.29743 9.32943 7.99609 9.03143 7.99609 8.66276C7.99609 8.29409 8.29143 7.99609 8.66009 7.99609H8.66609C9.03476 7.99609 9.33276 8.29409 9.33276 8.66276C9.33276 9.03143 9.03476 9.32943 8.66609 9.32943Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.33406 5.9974C4.9654 5.9974 4.66406 5.6994 4.66406 5.33073C4.66406 4.96206 4.9594 4.66406 5.32806 4.66406H5.33406C5.70273 4.66406 6.00073 4.96206 6.00073 5.33073C6.00073 5.6994 5.70273 5.9974 5.33406 5.9974Z"
				fill={color}
			/>
		</svg>
	);
}
